const genders = [
  { code: 'M', name: 'Male' },
  { code: 'F', name: 'Female' }
];

export default genders;
